import styled from "styled-components";
import { device } from "../../../devices.js";

const SportAZMenuWrapper = styled.div`
  @media ${device.desktopScreen} {
    .menu-item-list {
      overflow: auto;
      margin: 4.9rem 0.5rem 1rem 2rem;
    }
    z-index: 10;
    position: fixed;
    top: 0;
  }

  @media screen and (max-width: 1279px) and (min-width: 767px) {
    width: 32rem !important;
  }

  @media ${device.mobileScreen} {
    padding: 1rem 2rem 0 2rem;
  }
`;

export { SportAZMenuWrapper };
